import { getCookies, setCookie } from 'cookies-next';

export function getLanguage(): string | null {
  const cookies = getCookies();

  const languageCookie = cookies.lng;

  if (!languageCookie) {
    return null;
  }

  return languageCookie;
}

export function setLanguage(language: string): void {
  setCookie('lng', language.toLowerCase());
}
